import { render } from "./SchoolServices.vue?vue&type=template&id=9d14cade&ts=true"
import script from "./SchoolServices.vue?vue&type=script&lang=ts"
export * from "./SchoolServices.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__